<template>
    <i :class="iconClass" v-bind="$attrs">
        <template v-if="iconText">{{ iconText }}</template>
    </i>
</template>

<script>
import { resolveIconDisplay } from "@src/utils/iconDisplay.js";

export default {
    name: "AppIcon",
    inheritAttrs: false,
    props: {
        icon: {
            type: String,
            default: "",
        },
        fallback: {
            type: String,
            default: "fas fa-cog",
        },
    },
    computed: {
        display() {
            return resolveIconDisplay(this.icon, this.fallback);
        },
        iconClass() {
            return this.display.iconClass;
        },
        iconText() {
            return this.display.iconText;
        },
    },
};
</script>
